export default  {
    component: 'ups',
    name: 'ups',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Block ID',
            param: 'block_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> Should always start from ID **"1"**`
          },
          {
            name: 'Inverter Room',
            param: 'inverter_room',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, room id should start from **"1"**`
          },
          {
            name: 'UPS ID',
            param: 'ups_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `> For each block, ups id should start from **"1"**`
          },
          {
            name: 'Device ID',
            param: 'device_id',
            type: 'number',
            required: true,
            identifier: true,
            description: `Concatination for all the device ID's [1-1-1]`
          },
          {
            name: 'UPS Name',
            param: 'ups_name',
            type: 'text',
            description: `> For each block device name should be unique`
          },
          {
            name: 'Name Config',
            param: 'name_config',
            type: 'text',
            description: `The name should be unique. Name Concatination of blockname-roomname-devicename`
          },
          {
            name: 'Param Config',
            param: 'param_config',
            type: 'json',
          },
          {
            name: 'Parameter List',
            param: 'param_list',
            type: 'text',
            description: `In order to remove unwanted parameters from analytics. *\(e.g rm-ups_healthy,rm-ups_bypass)`
          }
    ]
  }





